import createStore from 'zustand/vanilla'

export const appConfig = createStore<AppConfig>(() => {
  const state = window.Gremlin ?? ({} as AppConfig)

  // Once stored, remove config from the global context
  delete window.Gremlin

  return state
})

export function isPrivateEdition() {
  return appConfig.getState().DEPLOYMENT_TYPE === 'private'
}
